import React from 'react'
import styled from 'styled-components'
import { colors } from '../../../styles/colors';

const MainCardContainer = styled.div`
    width: 420px;
    height: 430px;
    margin: 0 5rem;

    border: 1px solid ${colors.dark_blue};
    padding: 5rem;
    padding-bottom: 7rem;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    background: linear-gradient(180deg, rgba(79, 164, 217, 0.65) 0%, rgba(255, 255, 255, 0) 100%), #FFFFFF;

    @media (min-width: 960px) and (max-width: 1439.98px) {
        padding: 5rem 2.5rem 7rem 2.5rem;
    }
    @media (min-width: 768px) and (max-width: 959.98px) {
        width: 280px;
        position: absolute;
        justify-content: flex-start;
        margin: 0;
    }
    @media (max-width: 320px) {
        width: 100%;
        margin: 0;
        height: auto;
    }

    // INCLUDED CLASSES:
    
    .picture {
        width: 100%;
        height: 120px;

        background: url(${props => props.partner_picture}) no-repeat 50% 50%;
        background-size: contain;
    }
    .description {
        font-family: 'SF UI Text', sans-serif;
        font-weight: 300;
        font-size: 2.5rem;
        line-height: 150%;
        text-align: center;
        margin-top: 2rem;
    
        @media (max-width: 960px) {
            font-size: 2rem;
        }
    }
`
export const MainCard = ( { data } ) => {    
    return (
        <MainCardContainer partner_picture={data.partner_picture} className='main-card'>
            <div className="picture" />
            <p className="description"> {data.partner_description} </p>
        </MainCardContainer>
    )
}
